import { Icon } from "@albelli/arc-3-react/lib/Icon";
import { SideMenuItem, SideMenuSeparator } from "@albelli/arc-3-react/lib/SideMenu";
import { requestSignOut } from "application/auth/authActions";
import { commonMessages } from "components/common/commonMessages";
import { SideMenuNavItem } from "components/common/SideMenu/SideMenuNavItem";
import { useIntl } from "components/_hooks/useIntl";
import React, { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { routes } from "routes";
import styles from "./SideMenu.module.css";

export const SideMenu = () => {
  const intl = useIntl();
  const FAQ = useSelector(state => state.menu.items.routes.FAQ);
  const dispatch = useDispatch();
  const doSignOut = useCallback(e => {
    e.preventDefault();
    dispatch(requestSignOut());
  });

  return (
    <nav>
      <h1 className="arc3-hide-for-medium-up arc3-margin--left-lg arc3-margin--top">
        <FormattedMessage id="overview.title" />
      </h1>

      <SideMenuNavItem className="arc3-hide-for-small" href={routes.home} data-cy="overview">
        <Icon name="profile" size="small" />
        <FormattedMessage id="sideMenu.title" defaultMessage="My account" />
      </SideMenuNavItem>

      <SideMenuNavItem href={routes.savedProjects} data-cy="projects">
        <Icon name="folder" size="small" />
        <FormattedMessage id="sideMenu.mySavedProjects" defaultMessage="My saved projects" />
      </SideMenuNavItem>

      <SideMenuNavItem id="sideMenuOrders" href={routes.orders} data-cy="orders">
        <Icon name="delivery" size="small" />
        <FormattedMessage id="sideMenu.myOrders" defaultMessage="My orders" />
      </SideMenuNavItem>

      <SideMenuNavItem href={routes.settings} data-cy="settings">
        <Icon name="settings" size="small" />
        <FormattedMessage id="sideMenu.settings" defaultMessage="My settings" />
      </SideMenuNavItem>

      <SideMenuSeparator />
      <SideMenuItem href={FAQ} data-cy="faqs">
        <Icon name="question_mark_circle" size="small" />
        <FormattedMessage id="sideMenu.faq" defaultMessage="FAQs" />
      </SideMenuItem>

      <SideMenuSeparator />
      <a
        href="/"
        onClick={doSignOut}
        className={styles.signOutLink + " link--bold arc3-padding--left-lg arc3-padding--top arc3-hide-for-small"}
      >
        {intl.formatMessage(commonMessages.signOut)}
      </a>
    </nav>
  );
};
